import styled from 'styled-components';

import { FontSize } from '@ninox/ninox-components/theme';

export const BusinessMessage = styled.div`
    color: ${({ theme }) => theme.text.label};
    font-size: ${FontSize.x_large};
    text-align: center;
    line-height: 1.75;
`;
